import Toggle from '../../../components/ReusableComponents/Toggle'
import { getUSDstring } from '../../../utils/helpers'
import Balance from '../Balance'
import styles from '../BillingNew.module.scss'
import BillingRowHolder from '../BillingRowHolder'
import InvoiceRow from '../InvoiceRow'
import { invoiceStatusesAcceptableForTotalDueCalculation } from '../statusNames'
import BillingSupportInfo from './BillingSupportInfo'

const InvoicesColumn = ({
  balance,
  activeBalance,
  setShowingAddPaymentDialog,
  handleShowInvoiceContacts,
  isInternalAdmin,
  isGroupView,
  invoices,
  totalDue,
  showSkippedInvoices,
  setShowSkippedInvoices,
  searchValue,
  setSearchValue,
  filteredInvoices
}) => {
  return (
    <div className={styles.invoicesColumn}>
      <Balance
        balance={balance}
        activeBalance={activeBalance}
        handleAddPaymentClick={() => setShowingAddPaymentDialog(true)}
        handleSendEmailClick={handleShowInvoiceContacts}
        isInternalAdmin={isInternalAdmin}
        isGroupView={isGroupView}
        unpaidInvoiceIds={invoices
          .filter(i => invoiceStatusesAcceptableForTotalDueCalculation.includes(i.status))
          .map(i => i.subsidiaryInvoiceId)}
      />
      <BillingRowHolder
        title={
          isInternalAdmin ? (
            <div className={styles.billingRowTitle}>
              Total due: {getUSDstring(totalDue)}{' '}
              <div className={styles.skippedMonthFilter}>
                <Toggle
                  checked={showSkippedInvoices}
                  handleChange={e => setShowSkippedInvoices(e.target.checked)}
                  label="Show skipped"
                  mini
                />
              </div>
            </div>
          ) : (
            'Invoices'
          )
        }
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        isSearchable
      >
        {filteredInvoices.map(invoice => (
          <InvoiceRow
            isGroupView={isGroupView}
            key={invoice.subsidiaryInvoiceId}
            {...invoice}
          />
        ))}
      </BillingRowHolder>
      <BillingSupportInfo />
    </div>
  )
}

export default InvoicesColumn
